export default class SmoothUtils {

	static hide($element, callback) {
		$element.addClass('transparent');
		window.setTimeout(() => {
			$element.hide();
			if (callback) callback();
		}, 300);
	}

	static invisible($element, callback) {
		$element.addClass('transparent');
		window.setTimeout(() => {
			$element.addClass('invisible');
			if (callback) callback();
		}, 300);
	}

	static remove($element, callback) {
		$element.addClass('transparent');
		window.setTimeout(() => {
			$element.remove();
			if (callback) callback();
		}, 300);
	}

	static show($element, callback) {
		$element.show();
		$element.removeClass('transparent');
		window.setTimeout(() => {
			if (callback) callback();
		}, 300);
	}

	static visible($element, callback) {
		$element.removeClass('invisible');
		$element.removeClass('transparent');
		window.setTimeout(() => {
			if (callback) callback();
		}, 300);
	}

}
